import React, { useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ExtGearDisplacementPDF from "../components/ExtGearDisplacementPDF";

const PDFDownloader = ({ data }) => {
	/*
    data prop is an object containing following strings:
    D,
	gW,
	dimension,
	dimensionValue,
	units,
	resultString,
	created: moment().format('LLLL')
*/

	const [note, setNote] = useState("");

	const onNoteChange = (e) => {
		setNote(e.target.value);
	};

	const resetNote = () => {
		setNote("");
	};

	return (
		<div>
			<div style={styles.linkContainer}>
				<PDFDownloadLink
					document={<ExtGearDisplacementPDF data={{ ...data, note }} />}
					fileName="displacement.pdf"
					style={styles.linkStyle}
				>
					{"Download Result as PDF"}
				</PDFDownloadLink>
			</div>
			{/*<p style={styles.pStyle}>
				If your browser downloads this file as .txt file, you can either change
				the file's extension to .pdf or "right-click" and "save as" a file with
				.pdf extension
	</p>*/}
			<div style={styles.linkContainer}>
				<textarea
					name=""
					id=""
					cols="40"
					rows="5"
					placeholder="Add your note here  (optional)"
					value={note}
					onChange={onNoteChange}
					style={styles.textAreaStyle}
				></textarea>
			</div>
			<div style={styles.linkContainer}>
				<button type="button" onClick={resetNote} style={styles.buttonStyle}>
					Clear Note
				</button>
			</div>
		</div>
	);
};

const styles = {
	linkStyle: {
		color: "#0080C0",
		margin: "10px",
		fontSize: "20px",
	},
	linkContainer: {
		textAlign: "center",
		margin: "10px",
	},
	textAreaStyle: {
		width: "90%",
		fontSize: "18px",
	},
	buttonStyle: {
		width: "40%",
		padding: "5px",
		fontSize: "18px",
		display: "inline-block",
	},
	pStyle: {
		textAlign: "center",
	},
};

export default PDFDownloader;
